import Button from '@mui/material/Button'
import React, { useCallback, useState } from 'react'

import HHConfirmDialog from './HHConfirmDialog'

import type { ButtonProps } from '@mui/material/Button'

type Props = Omit<ButtonProps, 'onClick'> & {
  DialogProps?: Record<string, unknown>
  // Legacy callers still send it; the confirm dialog has never received it.
  CancelButtonProps?: Record<string, unknown>
  DeleteButtonProps?: Record<string, unknown>
  confirmTitle?: string
  confirmDescription?: React.ReactNode
  onDeleteConfirmed?: () => void
  onDeleteCanceled?: () => void
  deleteButtonTitle?: string
}

const HHConfirmDeleteButton: React.FC<Props> = ({
  DialogProps,
  CancelButtonProps: _cancelButtonProps,
  DeleteButtonProps,
  confirmTitle,
  confirmDescription,
  onDeleteConfirmed,
  onDeleteCanceled,
  deleteButtonTitle = 'Delete',
  size = 'medium',
  ...rest
}) => {
  const [open, setOpen] = useState(false)

  const handleClickOpen = useCallback(() => setOpen(true), [])

  const handleClose = useCallback(() => {
    setOpen(false)
    onDeleteCanceled?.()
  }, [onDeleteCanceled])

  const handleConfirm = useCallback(() => {
    setOpen(false)
    onDeleteConfirmed?.()
  }, [onDeleteConfirmed])

  return (
    <>
      <Button color="error" loadingPosition="end" size={size} {...rest} onClick={handleClickOpen}>
        {deleteButtonTitle}
      </Button>
      <HHConfirmDialog
        ConfirmButtonProps={DeleteButtonProps}
        confirmButtonTitle={deleteButtonTitle}
        confirmDescription={confirmDescription}
        confirmTitle={confirmTitle}
        DialogProps={DialogProps}
        isOpen={open}
        onClose={handleClose}
        onConfirm={handleConfirm}
      />
    </>
  )
}

export default HHConfirmDeleteButton
